// extracted by mini-css-extract-plugin
module.exports = {"formBox":"SimpleQuestionnaireCreateEdit_formBox__3KlUs"};